const header = document.querySelector("header");
const menuMobItems = [...document.querySelectorAll("header .nav")];
const menuMob = menuMobItems[0] || null;
const toggleMenu = document.querySelector("#toggleMenu");
const htmlOpen = document.documentElement;
let menuTrigger = null;
let mobileMenuTimeline = null;

let headerHeight = header ? header.offsetHeight : 0;
const mobileMenuQuery = window.matchMedia("(max-width: 980px)");
function initSmoothPageScroll() {
	const canUseSmoothScroll = typeof Lenis !== "undefined"
		&& window.matchMedia("(pointer: fine)").matches
		&& !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (!canUseSmoothScroll) {
		return;
	}

	const lenis = new Lenis({
		lerp: 0.16,
		smoothWheel: true,
		wheelMultiplier: 0.9,
		syncTouch: false,
	});


	function smoothScrollFrame(time) {
		lenis.raf(time);
		requestAnimationFrame(smoothScrollFrame);
	}

	requestAnimationFrame(smoothScrollFrame);
}

const sectionOffset = 32;

function updateHeaderHeight() {
	headerHeight = header ? header.offsetHeight : 0;
}

function resetMobileMenuVisualState() {
	menuMobItems.forEach((menu) => menu.classList.remove("open", "is-closing"));
}

function getMobileMenuLinks() {
	return menuMobItems.flatMap((menu) => [...menu.querySelectorAll("a")]);
}

function getMobileMenuTimeline() {
	if (!mobileMenuQuery.matches || !menuMob || typeof gsap === "undefined") {
		return null;
	}

	if (mobileMenuTimeline) {
		return mobileMenuTimeline;
	}

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return null;
	}

	const links = [...getMobileMenuLinks(), header?.querySelector(".button")].filter(Boolean);
	mobileMenuTimeline = gsap.timeline({
		paused: true,
		onComplete: () => menuMob.querySelector("a")?.focus(),
		onReverseComplete: () => {
			resetMobileMenuVisualState();
			htmlOpen.classList.remove("menu-active");
		},
	});

	mobileMenuTimeline.fromTo(
		links,
		{ autoAlpha: 0, x: -28, clipPath: "inset(0 100% 0 0)" },
		{ autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.44, stagger: 0.07, ease: "power3.out" },
	);

	return mobileMenuTimeline;
}

function setMobileMenusInert(isInert) {
	menuMobItems.forEach((menu) => {
		menu.inert = isInert;
	});
}

function closeMobileMenu({ restoreFocus = false } = {}) {
	if (!menuMob || !toggleMenu) {
		return;
	}

	const wasOpen = menuMobItems.some((menu) => menu.classList.contains("open"));
	toggleMenu.classList.remove("active");
	toggleMenu.setAttribute("aria-expanded", "false");
	toggleMenu.setAttribute("aria-label", "Abrir menu");
	setMobileMenusInert(mobileMenuQuery.matches);

	const timeline = getMobileMenuTimeline();
	if (wasOpen && timeline && timeline.progress() > 0) {
		menuMobItems.forEach((menu) => menu.classList.add("is-closing"));
		timeline.reverse();
	} else {
		resetMobileMenuVisualState();
		htmlOpen.classList.remove("menu-active");
	}

	if (restoreFocus && menuTrigger) {
		menuTrigger.focus();
	}
}

let lastScrollY = window.scrollY;
let hideTimeout = null;
const hideDelay = 300;

function setHeaderSticky() {
	if (!header) {
		return;
	}

	const currentScrollY = window.scrollY;
	const isFixed = currentScrollY > 0;
	const isMenuOpen = menuMobItems.some((menu) => menu.classList.contains("open"));

	header.classList.toggle("fixed", isFixed);

	if (!isFixed || isMenuOpen || currentScrollY < lastScrollY) {
		clearTimeout(hideTimeout);
		hideTimeout = null;
		header.classList.remove("hide");
	} else if (currentScrollY > lastScrollY && currentScrollY > headerHeight && !hideTimeout) {
		hideTimeout = setTimeout(() => {
			header.classList.add("hide");
			hideTimeout = null;
		}, hideDelay);
	}

	lastScrollY = currentScrollY;
}

let ticking = false;
function handleStickyOnScroll() {
	if (ticking) {
		return;
	}

	ticking = true;
	requestAnimationFrame(() => {
		setHeaderSticky();
		ticking = false;
	});
}

function scrollToSection(event) {
	if (!(event.target instanceof Element)) {
		return;
	}

	const link = event.target.closest('a[href^="#"]');
	if (!link) {
		return;
	}

	const href = link.getAttribute("href");
	if (!href || href === "#") {
		return;
	}

	let sectionId;
	try {
		sectionId = decodeURIComponent(href.slice(1));
	} catch (error) {
		return;
	}

	const section = document.getElementById(sectionId);
	if (!section) {
		return;
	}

	event.preventDefault();
	updateHeaderHeight();

	const sectionTop = section.getBoundingClientRect().top + window.scrollY;
	const offsetTop = Math.max(0, sectionTop - headerHeight + sectionOffset);

	window.scrollTo({
		top: offsetTop,
		behavior: "smooth",
	});

	closeMobileMenu();
}

function openMenuMobile(event) {
	if (event) {
		event.preventDefault();
	}

	if (!menuMob || !toggleMenu) {
		return;
	}

	const isOpen = menuMobItems.some((menu) => menu.classList.contains("open") && !menu.classList.contains("is-closing"));
	if (isOpen) {
		closeMobileMenu({ restoreFocus: true });
		return;
	}

	menuTrigger = toggleMenu;
	header?.classList.remove("hide");
	menuMobItems.forEach((menu) => {
		menu.classList.add("open");
		menu.classList.remove("is-closing");
	});
	htmlOpen.classList.add("menu-active");
	toggleMenu.classList.add("active");
	toggleMenu.setAttribute("aria-expanded", "true");
	toggleMenu.setAttribute("aria-label", "Fechar menu");
	setMobileMenusInert(false);

	const timeline = getMobileMenuTimeline();
	if (timeline) {
		timeline.play();
	} else {
		requestAnimationFrame(() => menuMob.querySelector("a")?.focus());
	}
}

function handleKeyboardNavigation(event) {
	if (event.key === "Escape") {
		closeMobileMenu({ restoreFocus: true });
	}
}

function syncMenuAccessibility() {
	if (!menuMob) return;

	if (!mobileMenuQuery.matches) {
		mobileMenuTimeline?.kill();
		mobileMenuTimeline = null;
		resetMobileMenuVisualState();
		setMobileMenusInert(false);

		if (typeof gsap !== "undefined") {
			gsap.set([...menuMobItems, ...getMobileMenuLinks(), header?.querySelector(".button")].filter(Boolean), { clearProps: "all" });
		}
		return;
	}

	menuMobItems.forEach((menu) => {
		menu.inert = !menu.classList.contains("open");
	});
}

function initNewsletterForminatorPlaceholders() {
	const newsletterForms = [...document.querySelectorAll("#newsletter .forminator-ui")];

	if (!newsletterForms.length) {
		return;
	}

	newsletterForms.forEach((form) => {
		const fields = [...form.querySelectorAll(".forminator-field:not(.forminator-field-consent)")];

		fields.forEach((field) => {
			const label = field.querySelector(".forminator-label");
			const input = field.querySelector("input:not([type='hidden']):not([type='checkbox']), textarea");

			if (!label || !input || input.getAttribute("placeholder")) {
				return;
			}

			const placeholder = label.textContent.replace(/\*/g, "").trim();

			if (placeholder) {
				input.setAttribute("placeholder", placeholder);
			}
		});
	});
}


window.addEventListener("scroll", handleStickyOnScroll, { passive: true });
window.addEventListener("resize", updateHeaderHeight, { passive: true });
window.addEventListener("keydown", handleKeyboardNavigation);
document.addEventListener("click", scrollToSection);
toggleMenu?.addEventListener("click", openMenuMobile);
mobileMenuQuery.addEventListener("change", () => {
	closeMobileMenu();
	syncMenuAccessibility();
});
function initSite() {
	const initializers = [
		initSmoothPageScroll,
		syncMenuAccessibility,
		initNewsletterForminatorPlaceholders,
		updateHeaderHeight,
		setHeaderSticky,
		initBannerAnimation,
		initBannerLPAnimation,
		initEvolutionLPAnimation,
		initInstitutionalCycleAnimation,
		initAboutAnimation,
		initAboutInsideAnimation,
		initContextAnimation,
		initSecurityAnimation,
		initAreasAnimation,
		initAreasInsideAnimation,
		initPartnersAnimation,
		initTeamAnimation,
		initTeamSwiper,
		initArticlesSwiper,
		initBoxNewsAnimation,
		initBoxArticlesAnimation,
		initBlogAnimation,
		initNewsletterAnimation,
	];

	initializers.forEach((initializer) => {
		try {
			initializer();
		} catch (error) {
			console.error(`Falha ao inicializar ${initializer.name}:`, error);
		}
	});
}

initSite();
